var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E7FF51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2 16H25.4V28.48L30.2 25.42V16ZM36.6 16H31.8V24.4H36.6V16ZM38.2 16H43V24.4H38.2V16ZM31.8 26V30.78H41L30.2 37.66V32H19.88H19V39.66L21 42V48H41V42L45 39.46V26H31.8ZM19 16H23.8V29.5L22.38 30.4H19V16Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/POWER.55ce4b61e6f164db316623b73ff4f69e.svg";
export { ForwardRef as ReactComponent };